// Webpack Imports
import * as bootstrap from 'bootstrap';
import $ from 'jquery';
import 'slick-carousel';

( function () {
	'use strict';

	// Focus input if Searchform is empty
	[].forEach.call( document.querySelectorAll( '.search-form' ), ( el ) => {
		el.addEventListener( 'submit', function ( e ) {
			var search = el.querySelector( 'input' );
			if ( search.value.length < 1 ) {
				e.preventDefault();
				search.focus();
			}
		} );
	} );

	// Initialize Popovers: https://getbootstrap.com/docs/5.0/components/popovers
	var popoverTriggerList = [].slice.call( document.querySelectorAll( '[data-bs-toggle="popover"]' ) );
	var popoverList = popoverTriggerList.map( function ( popoverTriggerEl ) {
		return new bootstrap.Popover( popoverTriggerEl, {
			trigger: 'focus',
		} );
	} );
	
} )();

$.fn.isInViewport = function() {

	var element = this.get(0);

	if (element) {
		var bounding = element.getBoundingClientRect();

		return (
			bounding.top >= 0 &&
			bounding.left >= 0 &&
			bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
			bounding.right <= (window.innerWidth || document.documentElement.clientWidth)
		);
	}

	return false;

};

$(window).on('resize scroll', function() {
	if ($('#offer').isInViewport()) {
		$("#jumpark-icon").addClass("animate__animated animate__swing");
	} else {
		$("#jumpark-icon").removeClass("animate__animated animate__swing");
	}
});


const buyContaineElement = document.querySelectorAll('.buy-ticket-container .col-auto img');

const buyObserver = new IntersectionObserver((entries, observer) => {
	entries.forEach(entry => {
		if (entry.isIntersecting) {
			entry.target.classList.add('slideIn'); // Add a CSS class to trigger the animation
			observer.unobserve(entry.target); // Stop observing once the element is animated
		}
	});
}, {
	threshold: 0.1 // Trigger the animation when 50% of the element is in the viewport
});

buyContaineElement.forEach(div => {
	buyObserver.observe(div);
});

const offerDivs = document.querySelectorAll('#offer > div:not(#jumpark-icon)');

const observer = new IntersectionObserver((entries, observer) => {
	entries.forEach(entry => {
		if (entry.isIntersecting) {
			entry.target.classList.add('fade-in'); // Add a CSS class to trigger the animation
			observer.unobserve(entry.target); // Stop observing once the element is animated
		}
	});
}, {
	threshold: 0.5 // Trigger the animation when 50% of the element is in the viewport
});

offerDivs.forEach(div => {
	observer.observe(div);
});

jQuery(function() {
    $('.home-carousel').slick({
        speed: 300,
        centerPadding: '15px',
        slidesToShow: 2,
        dots: false,
//        centerMode: true,
        focusOnSelect: true,
//        variableWidth: true,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    arrows: true,
//                    centerMode: true,
                    centerPadding: '15px',
                    slidesToShow: 2
                }
            },
            {
                breakpoint: 868,
                settings: {
                    arrows: true,
//                    centerMode: true,
                    centerPadding: '15px',
                    slidesToShow: 1
                }
            }
        ]
    });

	const simpleParallax = (elem, modifier) => {
		let paras = document.getElementsByClassName(elem);
		for (let i = 0; i < paras.length; i++) {
			paras[i].setAttribute(
			"style",
			"background-repeat: no-repeat; background-attachment: fixed; background-size: cover; background-position: center center;"
			);
		}
		const sp = () => {
			for (let i = 0; i < paras.length; i++) {
			let x = paras[i].getBoundingClientRect().top / modifier;
			let y = Math.round(x * 100) / 100;
			paras[i].style.backgroundPosition = "center " + y + "px";
			}
			requestAnimationFrame(sp);
		};
		requestAnimationFrame(sp);
	};
	
	simpleParallax("parallax", 8);


	var header = $('#header-nav-container'); // Change this to the ID or class of your header section
	var logo = $('.navbar-brand'); // Change this to the class or ID of your logo element
	var scrollPosition = $(window).scrollTop();

	$(window).on("scroll", function() {
		const currentScroll = $(this).scrollTop();
		if (currentScroll > scrollPosition) {
			logo.addClass('smaller');
		} else {
			logo.removeClass('smaller');
		}
		scrollPosition = currentScroll;
	});
});